<template>
  <div class="flex items-center gap-spacing_4">
    <span
      class="flex h-7 w-7 items-center justify-center rounded-full text-neutral-50"
      :class="{
        'bg-primary-300': state === 'locked',
        'bg-action': state !== 'locked',
      }"
    >
      <UIcons v-if="state === 'complete'" name="ic-check" class="h-6 w-6" />
      <span v-else class="text-size_4">{{ step }}</span>
    </span>

    <span
      v-if="title"
      class="step-title whitespace-nowrap font-secondary text-size_3 font-semibold"
    >
      {{ title }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import UIcons from "~/components/common/UIcons.vue";

withDefaults(
  defineProps<{
    state: "default" | "complete" | "locked";
    step: number;
    title?: string;
  }>(),
  {
    state: "default",
  },
);
</script>
